export default __webpack_public_path__ + "static/media/turkey.5ef0636b.jpg";